module.exports = __webpack_public_path__ + "img/CQJYZX.de2da85f.png";